import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const ReinviteDirector = React.createContext({});
export let ReinviteDirectorMachine: any;

const MODULE_NAME = 'machines.ReinviteDirector';

export const useSMReinviteDirector = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  ReinviteDirectorMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(ReinviteDirectorMachine);

  return {
    ReinviteDirectorMachine,
    ReinviteDirectorState: state,
    ReinviteDirectorSend: send,
  };
};
